import styled from "styled-components";

export const PaymentsSectionSection = styled.div.attrs({ className: "mt-8" })``;
